import { CrudForm } from '../shared/CrudPage';
import { tenantService, enumEntries } from '@kss/api';
import type { Tenant, TenantCreate, TenantFilter } from '@kss/api';

type F = {
  name: string; code: string; contactEmail: string; contactPhone: string;
  country: string; timeZone: string; currency: string; logoUrl: string;
  status: string;
};
const empty: F = {
  name: '', code: '', contactEmail: '', contactPhone: '',
  country: 'IN', timeZone: 'Asia/Kolkata', currency: 'INR', logoUrl: '',
  status: '1',
};

export default function NewTenant() {
  return (
    <CrudForm<Tenant, TenantCreate, TenantFilter, F>
      title="tenant" service={tenantService} idKey="tenantId" basePath="/panel/tenants" emptyForm={empty}
      fields={[
        { key: 'code', label: 'Tenant code', required: true, placeholder: 'acme' },
        { key: 'name', label: 'Display name', required: true, placeholder: 'Acme Retail Pvt Ltd' },
        { key: 'contactEmail', label: 'Contact email', type: 'email' },
        { key: 'contactPhone', label: 'Contact phone', type: 'tel' },
        { key: 'country', label: 'Country' },
        { key: 'currency', label: 'Currency', placeholder: 'INR' },
        { key: 'timeZone', label: 'Time zone', placeholder: 'Asia/Kolkata' },
        { key: 'logoUrl', label: 'Logo URL', type: 'url' },
        { key: 'status', label: 'Status', type: 'select', options: enumEntries('TenantStatus').map((e) => ({ value: String(e.value), label: e.label })) },
      ]}
      fromEntity={(r) => ({
        name: r.name ?? '', code: r.code ?? '',
        contactEmail: r.contactEmail ?? '', contactPhone: r.contactPhone ?? '',
        country: r.country ?? 'IN', timeZone: r.timeZone ?? 'Asia/Kolkata',
        currency: r.currency ?? 'INR', logoUrl: r.logoUrl ?? '',
        status: String(r.status ?? '1'),
      })}
      toEntity={(f, id) => ({
        tenantId: id, name: f.name, code: f.code || undefined,
        contactEmail: f.contactEmail || undefined, contactPhone: f.contactPhone || undefined,
        country: f.country || undefined, timeZone: f.timeZone || undefined,
        currency: f.currency || undefined, logoUrl: f.logoUrl || undefined,
        status: f.status ? Number(f.status) : undefined,
      })}
      validate={(f) => !f.name.trim() ? 'Name is required' : !f.code.trim() ? 'Tenant code is required' : null}
    />
  );
}
